export const isHttpLink = (value: string) => {
  // eslint-disable-next-line require-unicode-regexp,prefer-named-capture-group
  return /^(https?|ftp|torrent|image|irc):\/\/(-\.)?([^\s#?-]+\.?)+(\/\S*)?$/i.test(value)
}
